import { IconWrapper } from '@deprecated-ui/common/Iconmoon';
import PropTypes from 'prop-types';
import { CustomAvatar } from '../Search/options';

const IconProfile = ({ img, name, ...iconProps }) => (
  <IconWrapper {...iconProps} size="40px">
    <CustomAvatar img={img} name={name} />
  </IconWrapper>
);

IconProfile.propTypes = {
  img: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};

export default IconProfile;
